// Clinic

// Carousel

$(function () {
  const owlCarousel = $('.jsCarousel');
  owlCarousel.each(function () {
    const el = $(this);
    el.owlCarousel($.extend({
      loop: true
    }, el.data('carousel-options')));
  });
});
